// eslint-disable-next-line import/no-unassigned-import
import './replace-template-variables.scss';

export const replaceTemplateVariables = (
  html: string,
  variables: Record<string, number | string | undefined>,
  activeField: null | string,
  staticFields: string[] = [],
  isPrintable?: boolean
): string => {
  const replacer = (currentHtml: string) => (match: string, key: string, offset: number) => {
    const lookbackStart = Math.max(0, offset - 1000);
    const before = currentHtml.slice(lookbackStart, offset);
    const isInImgSource = /<img[^>]*src\s*=\s*["'][^"']*$/iu.test(before);

    if (isInImgSource) {
      return key in variables && variables[key] !== undefined ? String(variables[key]) : match;
    }

    if (variables[key] !== undefined) {
      if (staticFields.includes(key)) {
        return String(variables[key]);
      }

      const value = String(variables[key]);
      const classes = [
        'pdf-preview',
        isPrintable ? 'pdf-preview--printable' : '',
        activeField === key ? 'pdf-preview--active' : '',
      ]
        .filter(Boolean)
        .join(' ');

      return `<span class="${classes}" data-var="${key}">${value}</span>`;
    }

    return match;
  };

  let previous: string;
  let result = html;
  do {
    previous = result;
    result = result.replaceAll(/\{\{\s*(\w+)\s*\}\}/gu, replacer(previous));
  } while (result !== previous);

  if (isPrintable) {
    result = result.replaceAll(
      /<p([^>]*)>(.*?)<\/p>/gsu,
      (_match, attributes: string, content: string) => {
        const trimmed = content.replaceAll(/[\u00A0\u202F]/gu, '').trim();

        if (trimmed.length === 0) {
          return `<p${attributes}>${content}</p>`;
        }

        const cleaned = content.replaceAll(/[\u00A0\u202F]/gu, ' ');

        return `<p${attributes}>${cleaned}</p>`;
      }
    );
  }

  return result;
};
